/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  getList({ commit }, { id, param }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`course-classes/${id}/students?${new URLSearchParams(param)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { class_id, student_id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `course-classes/${class_id}/students/${student_id}?${new URLSearchParams(
            query,
          )}`,
        )
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putUpdate({ commit }, { class_id, student_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`course-classes/${class_id}/students/${student_id}`, payload)
        .then((response) => {
          commit("UPDATE_SUCCESS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  create({ commit }, payload) {
    console.log(payload);
    return new Promise((resolve, reject) => {
      axios
        .post("course-student", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  transfer({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-students/${id}/transfer`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  renew({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`course-students/${id}/renew`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getClassHistories({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `course-students/${id}/class-histories?${new URLSearchParams(query)}`,
        )
        .then((response) => {
          commit("SET_CLASS_HISTORIES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  putClassHistories({ commit }, { student_id, history_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `course-students/${student_id}/class-histories/${history_id}`,
          payload,
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  joinClass({ commit }, { student_id, class_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `course-students/${student_id}/class-enrollments/${class_id}`,
          payload,
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setClassHistories({ commit }, { histories }) {
    commit("SET_CLASS_HISTORIES", histories);
  },
};
